import React, { useEffect, useState } from 'react';

// apollo
import { useApolloClient } from '@apollo/react-hooks';

// history
import { useHistory } from 'react-router-dom';

// query
import { FIND_CLIENT_DATA_BY_CODE } from '../query/clients/client.query';

// blocked circuits
import { isCircuitBlocked, getBlockedCircuitMessage } from '../constants/blockedCircuits';

// swal
import Swal from 'sweetalert2';

import PaymentMercadoPago from './payment-mercadopago.page';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUniversity } from '@fortawesome/free-solid-svg-icons';

const PagosManagementPage = () => {
  const [isChecking, setIsChecking] = useState(true);
  const client = useApolloClient();
  const history = useHistory();

  useEffect(() => {
    const checkBlockedCircuit = async () => {
      const cli_code = localStorage.getItem('client_code');

      if (!cli_code) {
        setIsChecking(false);
        return;
      }

      try {
        const clientData = await client.query({
          query: FIND_CLIENT_DATA_BY_CODE,
          variables: { cli_code },
          fetchPolicy: 'no-cache',
        });

        const clientInfo = clientData?.data?.findClientByClientCode;

        if (clientInfo && isCircuitBlocked(clientInfo.circuito)) {
          // Cerrar sesión borrando token y client_code
          localStorage.removeItem('token');
          localStorage.removeItem('client_code');

          await Swal.fire({
            title: 'Acceso Restringido',
            text: getBlockedCircuitMessage(),
            icon: 'warning',
          });

          history.push('/');
          return;
        }
      } catch (error) {
        console.error('Error verificando circuito:', error);
      }

      setIsChecking(false);
    };

    checkBlockedCircuit();
  }, [client, history]);

  if (isChecking) {
    return (
      <div className='row m-3'>
        <div className='col text-center'>
          <p>Verificando acceso...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='row m-3 '>
      <div className='col'>
        <div className='row'>
          <div className='col'>
            <h3 className='text-center'>Pagos</h3>
          </div>
        </div>
        <div className='row mt-5 justify-content-center'>
          {/*
            <div className='col'>
            <a href='/pagos/banco' className='btn btn-primary btn-lg btn-block'>
              <FontAwesomeIcon icon={faUniversity} />
              <span className='ml-3'>Banco</span>
            </a>
          </div>
            */}

          <div className='col-10 col-md-4'>
            <PaymentMercadoPago />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PagosManagementPage;
